<template>
  <div class="flex-1 w-full">
    <div class="[&_p]:!mb-0">
      <p class="text-[#626262] text-[12px]">
        {{ title }}
      </p>
      <p class="text-[#333333] font-medium">
        {{ value }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrackingInfoCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: '-',
    },
  },
}
</script>
